export const REMINDER_KEY = 'motors-post-call-reminder';
export const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;

interface StorageReminders {
    [key: string]: {
        t: number;
    }
}

const isExpired = (reminder?: StorageReminders[number]) => {
    return reminder ? Date.now() - reminder.t > ONE_DAY_IN_MS : true;
};

const genReminderKey = (adId: number, userId?: number) => {
    return userId ? `${adId}-${userId}` : `${adId}`;
};

export const setReminder = (adId: number, userId: number): void => {
    const reminders = getReminders();
    const key = genReminderKey(adId, userId);
    // if reminder already exists, do not set again
    if (reminders[key]) return;
    reminders[key] = { t: Date.now() };
    localStorage.setItem(REMINDER_KEY, JSON.stringify(reminders));
};

export const getReminders = () => {
    const value = localStorage.getItem(REMINDER_KEY);
    try {
        return value ? JSON.parse(value) as StorageReminders : {};
    } catch (_) {
        return {};
    }
};

// reminder already existed in the past
export const hasReminder = (adId: number, userId: number): boolean => {
    const reminders = getReminders();
    const key = genReminderKey(adId, userId);
    return reminders[key] ? true : false;
};

export const hasValidReminder = (adId: number, userId: number): boolean => {
    const reminders = getReminders();
    // not logged in -> logged in: continue to show
    if (userId) {
        const notLoggedInKey = genReminderKey(adId);
        const reminder = reminders[notLoggedInKey];
        if (reminder && !isExpired(reminder)) return true;
    }

    const reminder = reminders[genReminderKey(adId, userId)];
    return !isExpired(reminder);
};
